import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "fields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.checkboxTarget.checked
    this.fieldsTarget.classList.toggle("d-none", !enabled)
    this.fieldsTarget.querySelectorAll("input, select").forEach((field) => {
      field.disabled = !enabled
    })
  }
}
